import qs from 'qs'
import { List, Map } from 'immutable'
import { Action, any, AsyncState, browserRouter, Fun, loadingAsyncState, nothing, Option, Pair, unloadedAsyncState, Widget, mk_pair, some, async, IOWidget } from 'widgets-for-react'
import { Block } from '../wordpress/types_and_parser/standard_blocks.gen'
import { BlocksRenderer } from '../cms/blocks/block_to_widget.gen'
import { Breadcrumb } from '../wordpress/types_and_parser/extra_types.mod'
import { defaultPage, HeaderState, ContentType, emptyAppState, PublicSiteState, OptionsState } from '../public_site.main.mod'
import { EntryClient } from '../cms/widget.gen'
import { ExtraImages } from './utils/extra_images.mod'
import { Page } from '../cms/page/types.gen'
import { pageDisplay } from './blocks/renderer.mod'
import { PageStateZero } from '../cms/state/utils.gen'
import { PageTemplateState, AppState } from '../cms/state/types.gen'
import { ParsedNode } from '../wordpress/types_and_parser/types.ext.gen'
import { PublicSiteCustomRoutes, CustomPages } from './custom_pages/types.mod'
import { TransformStandardBlock, WordPressBlock_To_WidgetBlock } from '../wordpress/wordpress_to_cms.gen'
import { WordPress } from '../wordpress/wordpress_api'
import { WordPressBlockImagesLoader } from '../wordpress/rendering/image_utils.mod'
import { CustomBlock } from '../wordpress/types_and_parser/custom_blocks.mod'
import { CustomBlockData } from './blocks/custom_blocks/types.mod'
import { history } from './templates/history.mod'
import { ExtraParameters } from '../cms/router/type.gen'
import { unescapeHTML } from '../../utils'
import { cookiebar } from '../cms/blocks/widgets/cookiebar/cookiebar.widget'
import { CustomBlock_To_Widget } from './CustomBlockToWidget'

export const defaultLang: string = "en";
export let lang: string = defaultLang;
export const availableLanguages = [
  { short: 'nl', full: 'Nederlands' },
  { short: 'en', full: 'English' },
  { short: 'de', full: 'German' }
]

export type PublicSite_CustomPageData = {
  posts: Map<number, AsyncState<WordPress.PostTypeResponse>>
  post: WordPress.PostTypeResponse
  latest_articles: AsyncState<Array<WordPress.PostTypeResponse>>
  news: WordPress.Overview<'news'>
  stories: WordPress.Overview<'story'>
  extra_params?: ExtraParameters
}

const removeLangFromSlug = (slug, lang) => {
  if (slug) {
    var pathArray = slug.split('/');
    if (!pathArray[0]) pathArray.shift();
    if (pathArray[0] == lang && (lang == 'en' || lang == "nl" || lang == "de")) {
      lang = pathArray[0]
      pathArray.shift();
    }
    slug = `/${pathArray.join('/')}`
  }
  return slug
}

export const langToUrl = (lang) =>
  lang == 'en' ? '/en' : `/${lang}`

const closeSearchAndMenu = s1 => (
  {
    ...s1,
    state: {
      ...s1.state,
      header: {
        ...s1.state.header,
        menu: 'closed',
        hoveredItem: null,
        showSearchBar: false
      }
    }
  }
)

export function asyncPost<PT>(id: number, lang: string): AsyncState<WordPress.PostTypeResponse> {
  return loadingAsyncState<WordPress.PostTypeResponse>(_ =>
    WordPress.api()
      .anypost(id)
      .then(response =>
        response.data ? { kind: 'result', status: 200, value: response.data } : { kind: 'failed', status: 404 }
      )
  )
}

export function asyncPosts(args?: WordPress.PostRequestArguments): AsyncState<Array<WordPress.PostTypeResponse>> {
  return loadingAsyncState<Array<WordPress.PostTypeResponse>>(_ =>
    WordPress.api<WordPress.PostTypeResponse>()
      .select('post')
      .where(args)
      .getMultiple()
      .then(response =>
        response.data
          ? { kind: 'result', status: 200, value: response.data }
          : {
            kind: 'failed',
            status: 404
          }
      )
  )
}

function loadExtraPostData(post: WordPress.PostTypeResponse): PublicSite_CustomPageData {
  let posts = Map<number, AsyncState<WordPress.PostTypeResponse>>()
  let latest_articles = unloadedAsyncState<Array<WordPress.PostTypeResponse>>()
  let news: WordPress.Overview<'news'>;
  let stories: WordPress.Overview<'story'>;
  const searchParams: URLSearchParams = new URL(location.href).searchParams

  var params = qs.parse(window.location.search, { ignoreQueryPrefix: true })
  let category = params.category as any
  let year = params.year as any

  const currentPage = searchParams.has('page') ? parseInt(searchParams.get('page')) : 1

  const reqArgs = {
    per_page: 12,
    page: currentPage
  }

  if (post.type == 'page' && post.template == 'news-overview') {

    const categoryFilter = {
      news_taxonomy: category
    }
    const yearFilter: WordPress.PostRequestArguments = year ? {
      after: `${year}-01-01T00:00:00+01:00`,
      before: `${parseInt(year) + 1}-01-01T00:00:00+01:00`
    } : {}

    news = {
      current_page: searchParams.has('page') ? parseInt(searchParams.get('page')) : 1,
      kind: 'news',
      categories: loadingAsyncState<Array<WordPress.TaxonomyResponse>>(_ =>
        WordPress.api<WordPress.TaxonomyResponse>()
          .terms('news_taxonomy')
          .then(response => response.data
            ? {
              kind: 'result',
              status: 200,
              value: response.data
            }
            : {
              kind: 'failed',
              status: 404
            }
          )
      ),
      years: loadingAsyncState<Array<number>>(_ =>
        WordPress.api<number>()
          .years('news')
          .then(response => response.data
            ? {
              kind: 'result',
              status: 200,
              value: response.data
            }
            : {
              kind: 'failed',
              status: 404
            }
          )
      ),
      async: loadingAsyncState<WordPress.OverviewResponse>(_ =>
        WordPress.api<WordPress.NewsArticleResponse>()
          .select('news')
          .where({
            ...reqArgs,
            ...categoryFilter,
            ...yearFilter
          })
          .getMultiple()
          .then(response => response.data
            ? {
              kind: 'result', status: 200, value: {
                total_pages: response.headers["x-wp-totalpages"],
                total_articles: response.headers["x-wp-total"],
                kind: 'news',
                posts: response.data
              }
            }
            : {
              kind: 'failed',
              status: 404
            }
          )
      )
    }
  }

  if (post.type == 'page' && post.template == 'story-overview') {
    const categoryFilter = {
      story_taxonomy: category
    }

    stories = {
      current_page: searchParams.has('page') ? parseInt(searchParams.get('page')) : 1,
      kind: 'story',
      categories: loadingAsyncState<Array<WordPress.TaxonomyResponse>>(_ =>
        WordPress.api<WordPress.TaxonomyResponse>()
          .terms('story_taxonomy')
          .then(response => response.data
            ? {
              kind: 'result',
              status: 200,
              value: response.data
            }
            : {
              kind: 'failed',
              status: 404
            }
          )
      ),
      async: loadingAsyncState<WordPress.OverviewResponse>(_ =>
        WordPress.api<WordPress.StoryResponse>()
          .select('story')
          .where({
            ...reqArgs,
            ...categoryFilter
          })
          .getMultiple()
          .then(response => response.data
            ? {
              kind: 'result', status: 200, value: {
                total_pages: response.headers["x-wp-totalpages"],
                total_articles: response.headers["x-wp-total"],
                kind: 'story',
                posts: response.data,
              }
            }
            : {
              kind: 'failed',
              status: 404
            }
          )
      )
    }
  }

  return {
    posts,
    post,
    latest_articles,
    stories,
    news
  }
}

export const InitPagesStates: (
  blocks_renderer: BlocksRenderer<CustomBlockData, ExtraImages, PublicSite_CustomPageData>
) => PageTemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData, PublicSiteState> = b => ({
  page: PageStateZero<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData, PublicSiteState>(
    () => unloadedAsyncState(),
    defaultPage,
    pageDisplay(b)
  ).page
})

export const ERROR_PAGE_SLUG = '/not-found'

export const get_page = (
  slug: string,
  extra_parameters: ExtraParameters
): AsyncState<Page<CustomBlock, Block, PublicSite_CustomPageData>> =>
  loadingAsyncState(_ => {
    slug = removeLangFromSlug(slug, lang)

    var params = qs.parse(window.location.search, { ignoreQueryPrefix: true });
    if (params.preview || params.preview_id) {

      let preview_id = params.preview_id || params.page_id || params.p
      slug = `/previews/${preview_id}`
    }

    return WordPress.api()
      .current(slug)
      .then(response => {
        return response.data && response.data.acf
          ? {
            kind: 'result',
            value: {
              blocks: response.data.custom_blocks ? response.data.custom_blocks.map(b => TransformStandardBlock(b)) : [],
              extra_data: { ...loadExtraPostData(response.data), extra_params: extra_parameters }
            },
            status: 200
          }
          : { kind: 'failed', status: 404 }
      })
      .catch(e => {
        if (slug != ERROR_PAGE_SLUG) {
          return WordPress.api()
            .current(ERROR_PAGE_SLUG)
            .then(response => {
              return response.data && response.data.acf
                ? {
                  kind: 'result',
                  value: {
                    blocks: response.data.custom_blocks ? response.data.custom_blocks.map(b => TransformStandardBlock(b)) : [],
                    extra_data: { ...loadExtraPostData(response.data), extra_params: extra_parameters }
                  },
                  status: 200
                }
                : { kind: 'failed', status: 404 }
            })
            .catch(e2 => {
              console.error(e2)
              return e2
            })
        }
        else {
          console.error(e)
          return e
        }
      })
  })

export function get_options(id: string): AsyncState<WordPress.OptionsResponse> {
  return loadingAsyncState<WordPress.OptionsResponse>(_ =>
    WordPress.api()
      .options(id)
      .then(response => {
        return response.data
          ? { kind: 'result', status: 200, value: response.data }
          : {
            kind: 'failed',
            status: 404
          }
      })
  )
}

const getPost = (id: number) =>
  WordPress.api()
    .anypost(id)
    .then(response => {
      console.log('response', response)
      return response.data
        ? ({ kind: 'result', status: 200, value: response.data } as any)
        : {
          kind: 'failed',
          status: 404
        }
    })
    .catch(e => {
      console.log(e)
      return { kind: 'failed', status: 500 } as any
    })

export const application = (
  data: { rootpath: string; rootpath_to_ignore: string; login_address?: string },
  header: (_: HeaderState, o: OptionsState) => Widget<Action<HeaderState>>,
  footer: (
    _: AppState<PublicSiteState, PublicSiteCustomRoutes>
  ) => Widget<Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>>,
  errorPage: IOWidget<PublicSiteState, never>,
  loadingPage: Widget<never>,
  page: Fun<Pair<List<Breadcrumb>, Option<ParsedNode>>, ContentType>,
  custom_pages: CustomPages
) => {
  lang = window.wp.language;
  let rootpath = data.rootpath ? data.rootpath : ''
  let rootpath_to_ignore = data.rootpath_to_ignore ? data.rootpath_to_ignore : ''

  return (s0: AppState<PublicSiteState, PublicSiteCustomRoutes>) => {
    return browserRouter<Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>>()(
      s0.route.kind == 'ignore'
        ? nothing()
        : any<Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>>()([
          async<WordPress.OptionsResponse>(_ => nothing())(s0.state.options).map<
            Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>
          >(a => s => {
            let s1 = a(s.state.options)

            return s1.kind == 'loaded'
              ? {
                ...s0,
                state: {
                  ...s0.state,
                  options: s1
                }
              }
              : s0
          }),

          s0.state.page.page.kind == 'loaded'
            ? async<Array<WordPress.PostTypeResponse>>(_ => nothing())(
              s0.state.page.page.value.extra_data.latest_articles
            ).map<Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>>(a => s => {
              if (s.state.page.page.kind != 'loaded') return s

              return {
                ...s,
                state: {
                  ...s.state,
                  page: {
                    ...s.state.page,
                    page: {
                      ...s.state.page.page,
                      value: {
                        ...s.state.page.page.value,
                        extra_data: {
                          ...s.state.page.page.value.extra_data,
                          latest_articles: a(s.state.page.page.value.extra_data.latest_articles)
                        }
                      }
                    }
                  }
                }
              }
            })
            : nothing(),

          s0.state.page.page.kind == 'loaded' &&
            s0.state.page.page.value.extra_data.post.type == 'page' &&
            s0.state.page.page.value.extra_data.post.template == 'news-overview'
            ? async<WordPress.OverviewResponse>(_ => nothing())(s0.state.page.page.value.extra_data.news.async).map<
              Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>
            >(a => s => {
              if (s.state.page.page.kind != 'loaded') return s

              return {
                ...s,
                state: {
                  ...s.state,
                  page: {
                    ...s.state.page,
                    page: {
                      ...s.state.page.page,
                      value: {
                        ...s.state.page.page.value,
                        extra_data: {
                          ...s.state.page.page.value.extra_data,
                          news: {
                            ...s.state.page.page.value.extra_data.news,
                            async: a(s.state.page.page.value.extra_data.news.async)
                          }
                        }
                      }
                    }
                  }
                }
              }
            })
            : nothing(),

          s0.state.page.page.kind == 'loaded' &&
            s0.state.page.page.value.extra_data.post.type == 'page' &&
            s0.state.page.page.value.extra_data.post.template == 'news-overview' &&
            s0.state.page.page.value.extra_data.news.kind == 'news'
            ? async<Array<number>>(_ => nothing())(s0.state.page.page.value.extra_data.news.years).map<
              Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>
            >(a => s => {
              if (s.state.page.page.kind != 'loaded') return s

              return {
                ...s,
                state: {
                  ...s.state,
                  page: {
                    ...s.state.page,
                    page: {
                      ...s.state.page.page,
                      value: {
                        ...s.state.page.page.value,
                        extra_data: {
                          ...s.state.page.page.value.extra_data,
                          news: {
                            ...s.state.page.page.value.extra_data.news,
                            years: a(s.state.page.page.value.extra_data.news.kind == 'news' ? s.state.page.page.value.extra_data.news.years : null)
                          }
                        }
                      }
                    }
                  }
                }
              }
            })
            : nothing(),
          s0.state.page.page.kind == 'loaded' &&
            s0.state.page.page.value.extra_data.post.type == 'page' &&
            s0.state.page.page.value.extra_data.post.template == 'news-overview' &&
            s0.state.page.page.value.extra_data.news.kind == 'news'
            ? async<Array<WordPress.TaxonomyResponse>>(_ => nothing())(s0.state.page.page.value.extra_data.news.categories).map<
              Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>
            >(a => s => {
              if (s.state.page.page.kind != 'loaded') return s

              return {
                ...s,
                state: {
                  ...s.state,
                  page: {
                    ...s.state.page,
                    page: {
                      ...s.state.page.page,
                      value: {
                        ...s.state.page.page.value,
                        extra_data: {
                          ...s.state.page.page.value.extra_data,
                          news: {
                            ...s.state.page.page.value.extra_data.news,
                            categories: a(s.state.page.page.value.extra_data.news.kind == 'news' ? s.state.page.page.value.extra_data.news.categories : null)
                          }
                        }
                      }
                    }
                  }
                }
              }
            })
            : nothing(),


          s0.state.page.page.kind == 'loaded' &&
            s0.state.page.page.value.extra_data.post.type == 'page' &&
            s0.state.page.page.value.extra_data.post.template == 'story-overview'
            ? async<WordPress.OverviewResponse>(_ => nothing())(s0.state.page.page.value.extra_data.stories.async).map<
              Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>
            >(a => s => {
              if (s.state.page.page.kind != 'loaded') return s

              return {
                ...s,
                state: {
                  ...s.state,
                  page: {
                    ...s.state.page,
                    page: {
                      ...s.state.page.page,
                      value: {
                        ...s.state.page.page.value,
                        extra_data: {
                          ...s.state.page.page.value.extra_data,
                          stories: {
                            ...s.state.page.page.value.extra_data.stories,
                            async: a(s.state.page.page.value.extra_data.stories.async)
                          }
                        }
                      }
                    }
                  }
                }
              }
            })
            : nothing(),
          s0.state.page.page.kind == 'loaded' &&
            s0.state.page.page.value.extra_data.post.type == 'page' &&
            s0.state.page.page.value.extra_data.post.template == 'story-overview' &&
            s0.state.page.page.value.extra_data.stories.kind == 'story'
            ? async<Array<WordPress.TaxonomyResponse>>(_ => nothing())(s0.state.page.page.value.extra_data.stories.categories).map<
              Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>
            >(a => s => {
              if (s.state.page.page.kind != 'loaded') return s

              return {
                ...s,
                state: {
                  ...s.state,
                  page: {
                    ...s.state.page,
                    page: {
                      ...s.state.page.page,
                      value: {
                        ...s.state.page.page.value,
                        extra_data: {
                          ...s.state.page.page.value.extra_data,
                          stories: {
                            ...s.state.page.page.value.extra_data.stories,
                            categories: a(s.state.page.page.value.extra_data.stories.kind == 'story' ? s.state.page.page.value.extra_data.stories.categories : null)
                          }
                        }
                      }
                    }
                  }
                }
              }
            })
            : nothing(),
          any<Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>>()(
            s0.state.page.page.kind == 'loaded'
              ? s0.state.page.page.value.extra_data.posts
                .map((p, key) =>
                  async<WordPress.PostTypeResponse>(_ => nothing())(p).map<
                    Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>
                  >(a => s => {
                    if (s.state.page.page.kind != 'loaded') return s
                    let a1 = a(s.state.page.page.value.extra_data.posts.get(key))
                    return {
                      ...s,
                      state: {
                        ...s.state,
                        page: {
                          ...s.state.page,
                          page: {
                            ...s.state.page.page,
                            value: {
                              ...s.state.page.page.value,
                              extra_data: {
                                ...s.state.page.page.value.extra_data,
                                posts: s.state.page.page.value.extra_data.posts.set(key, a1)
                              }
                            }
                          }
                        }
                      }
                    }
                  })
                )
                .valueSeq()
                .toArray()
              : [nothing()]
          ),

          header(s0.state.header, s0.state.options).map<Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>>(
            a => s1 => ({
              ...s1,
              state: { ...s1.state, header: a(s1.state.header) }
            })
          ),

          EntryClient<
            CustomBlockData,
            CustomBlock,
            Block,
            PublicSiteState,
            keyof CustomPages,
            PublicSiteCustomRoutes,
            ExtraImages,
            PublicSite_CustomPageData
          >({
            initState: emptyAppState(page),
            custom_pages,
            StandardBlockImagesLoader: WordPressBlockImagesLoader,
            StandardBlock_To_Widget: WordPressBlock_To_WidgetBlock,
            errorPage: errorPage,
            loadingPage: loadingPage,
            rootpath: rootpath,
            rootpath_to_ignore: rootpath_to_ignore,
            CustomBlock_To_Widget: CustomBlock_To_Widget,
            CustomBLockImagesLoader: (c: CustomBlock) => []
          })(s0),

          footer(s0).map<Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>>(a => s1 => a(s1)),
          history().map<Action<AppState<PublicSiteState, PublicSiteCustomRoutes>>>(la => {
            la.action == 'PUSH' && window.scrollTo(0, 0)
            return closeSearchAndMenu
          }),
        ])
    ).map<AppState<PublicSiteState, PublicSiteCustomRoutes>>(a => {
      let s1 = a(s0)

      if (s1.state.page.page.kind == "loaded" && s0.state.page.page.kind != "loaded") {
        s1.state.page.display = page(mk_pair(List(), some(s1.state.page.page.value.extra_data.post)))
      }

      if (s0.route != s1.route) {
        s1 = closeSearchAndMenu(s1)
      }

      if (
        s1.state.page.page.kind == 'loaded' &&
        s1.state.page.page.value.extra_data.post.yoast &&
        s1.state.page.page.value.extra_data.post.yoast.title
      ) {
        document.title = unescapeHTML(s1.state.page.page.value.extra_data.post.yoast.title)
      }

      s1.state.header.menu == 'open' ?
        document.documentElement.classList.add('menu--open')
        : document.documentElement.classList.remove('menu--open')

      if (s1.state.header.menu == 'open' || s1.state.header.showSearchBar) {
        document.body.setAttribute('data-scroll', 'locked')
      } else {
        document.body.setAttribute('data-scroll', '')
      }

      if (s1.route != s0.route) {
        document.getElementsByClassName("header")[0].scrollIntoView()
      }
      return s1
    })
  }
}
